import { useNavigate } from 'react-router-dom';
import { Avatar } from '../../components/ui/bits';
import { Swords } from '../../components/ui/icons';
import { useHaptics } from '../../hooks/useHaptics';
import type { Duel } from '@h2h/shared';

export function IncomingChallenges({
  incoming,
  users,
  onRespond,
  respondPending
}: {
  incoming: Duel[];
  users: Record<string, { displayName?: string; avatarTone?: number }> | undefined;
  onRespond: (duelId: string, accept: boolean) => void;
  respondPending: boolean;
}) {
  const navigate = useNavigate();
  const { impact } = useHaptics();

  return (
    <>
      {incoming.map((d) => {
        const u = users?.[d.challengerId];
        return (
          <div key={d.duelId} className="pt-4">
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-accent to-accent-deep p-[18px] shadow-featured">
              <span className="pointer-events-none absolute -bottom-[50px] -right-[40px] h-[160px] w-[160px] rounded-full bg-white/10" />
              <div className="relative">
                <button
                  type="button"
                  onClick={() => {
                    impact('light');
                    navigate(`/duel/${d.duelId}`);
                  }}
                  className="tap flex w-full items-center gap-[11px] text-left"
                >
                  <Avatar name={u?.displayName ?? 'Friend'} tone={u?.avatarTone ?? 2} size={44} />
                  <div className="min-w-0 flex-1">
                    <div className="truncate text-[15px] font-extrabold tracking-snug text-white">
                      {(u?.displayName ?? 'A friend')} challenged you
                    </div>
                    <div className="truncate text-[12px] font-semibold text-white/85">
                      Head-to-head · tap to see the duel
                    </div>
                  </div>
                  <div className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-white/20">
                    <Swords width={15} height={15} strokeWidth={2} className="text-white" />
                  </div>
                </button>
                <div className="mt-[15px] flex gap-[9px]">
                  <button
                    type="button"
                    disabled={respondPending}
                    onClick={() => {
                      impact('medium');
                      onRespond(d.duelId, true);
                    }}
                    className="tap flex-1 rounded-[13px] bg-white py-3 text-center text-[14px] font-extrabold text-accent-ink shadow-pill"
                  >
                    Accept
                  </button>
                  <button
                    type="button"
                    disabled={respondPending}
                    onClick={() => {
                      impact('light');
                      onRespond(d.duelId, false);
                    }}
                    className="tap flex-1 rounded-[13px] border border-white/30 bg-white/[0.18] py-3 text-center text-[14px] font-bold text-white"
                  >
                    Later
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
